import React, { useEffect, useState } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import ShopStore from '../components/merchant/ShopStore';
import Loading from '../components/common/Loading';

const ShopStoreWrapper = () => {
  const { user } = useAuth();
  const [shop, setShop]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    let unsub = null;
    const init = async () => {
      try {
        const mDoc   = await getDoc(doc(db, 'merchants', user.uid));
        const shopId = mDoc.data()?.shopId;
        if (!shopId) { setLoading(false); return; }
        unsub = onSnapshot(doc(db, 'shops', shopId), snap => {
          if (snap.exists()) setShop({ id: snap.id, ...snap.data() });
          setLoading(false);
        });
      } catch (err) {
        console.error('ShopStoreWrapper:', err);
        setLoading(false);
      }
    };
    init();
    return () => { if (unsub) unsub(); };
  }, [user]);

  if (loading) return <Loading message="Chargement…"/>;
  if (!shop)   return <Loading message="Boutique introuvable…"/>;

  return <ShopStore shop={shop}/>;
};

export default ShopStoreWrapper;